// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__fTiV5","label":"LabeledBox_label__3BPjz"};